<template>
  <router-view />
  <BaseToast />
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import BaseToast from '@/components/BaseToast.vue'

export default defineComponent({
  name: 'App',
  components: { BaseToast }
})
</script>
